/**
 * @description 图片预览功能Hook
 * @date 2025-01-17
 * @author lv.chen
 */

import { useState } from 'react';

interface IUseImagePreviewReturn {
  /** 是否显示图片预览 */
  isImagePreviewVisible: boolean;
  /** 图片列表 */
  imageList: string[];
  /** 打开图片预览 */
  openImagePreview: (images: string[]) => void;
  /** 关闭图片预览 */
  closeImagePreview: () => void;
}

/**
 * 图片预览功能Hook
 */
export default function useImagePreview(): IUseImagePreviewReturn {
  const [isImagePreviewVisible, setIsImagePreviewVisible] = useState(false);
  const [imageList, setImageList] = useState<string[]>([]);

  /**
   * 打开图片预览
   */
  const openImagePreview = (images: string[]): void => {
    setImageList(images);
    setIsImagePreviewVisible(true);
  };

  /**
   * 关闭图片预览
   */
  const closeImagePreview = (): void => {
    setImageList([]);
    setIsImagePreviewVisible(false);
  };

  return {
    isImagePreviewVisible,
    imageList,
    openImagePreview,
    closeImagePreview,
  };
}
